import React from 'react';
import { FDBox } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { HeadlineTextMedium } from 'Packages/FacetDesign/Components';

export const FrequentlyAskedQuestionsTitle = ({ value }) => {
  return (
    <FDBox paddingX={2}>
      <HeadlineTextMedium value={value} color={'textSecondary'} />
    </FDBox>
  );
};

FrequentlyAskedQuestionsTitle.propTypes = {
  value: PropTypes.string.isRequired,
};
